"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleWorkerPool = exports.SimpleWorker = void 0;
exports.createWorkerPoolFromCode = createWorkerPoolFromCode;
var runnable_1 = require("./runnable");
var SimpleWorker = /** @class */ (function () {
    function SimpleWorker(workerUrl) {
        var _this = this;
        this.queue = new runnable_1.TaskQueue();
        this.disposed = false;
        this.worker = new Worker(workerUrl);
        this.worker.onmessage = function (e) {
            var _a = e.data, data = _a.data, error = _a.error;
            error ? _this.reject(error) : _this.resolve(data);
        };
    }
    SimpleWorker.prototype.process = function (data) {
        var _this = this;
        if (this.isDisposed())
            throw new Error("This worker is disposed");
        return this.queue.run(function () {
            return new Promise(function (resolve, reject) {
                _this.resolve = resolve;
                _this.reject = reject;
                _this.worker.postMessage(data);
            });
        });
    };
    SimpleWorker.prototype.isDisposed = function () {
        return this.disposed;
    };
    SimpleWorker.prototype.dispose = function () {
        var _this = this;
        if (!this.isDisposed()) {
            this.queue.run(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, this.worker.terminate()];
            }); }); }).catch(function () { });
            this.disposed = true;
        }
    };
    return SimpleWorker;
}());
exports.SimpleWorker = SimpleWorker;
var SimpleWorkerPool = /** @class */ (function () {
    function SimpleWorkerPool(workerUrl, count) {
        this.disposed = false;
        this.workers = Array.from({ length: count }, function () { return ({
            worker: new SimpleWorker(workerUrl),
            queue: new runnable_1.TaskQueue(),
        }); });
    }
    SimpleWorkerPool.prototype.process = function (data) {
        var _this = this;
        if (this.isDisposed())
            throw new Error("This worker is disposed");
        return new Promise(function (resolve, reject) {
            var queued = false;
            _this.workers.forEach(function (_a) {
                var worker = _a.worker, queue = _a.queue;
                return queue.run(function () {
                    if (queued)
                        return;
                    queued = true;
                    return worker.process(data).then(resolve, reject);
                });
            });
        });
    };
    SimpleWorkerPool.prototype.isDisposed = function () {
        return this.disposed;
    };
    SimpleWorkerPool.prototype.dispose = function () {
        if (!this.isDisposed()) {
            this.workers.forEach(function (_a) {
                var worker = _a.worker;
                return worker.dispose();
            });
            this.disposed = true;
        }
    };
    return SimpleWorkerPool;
}());
exports.SimpleWorkerPool = SimpleWorkerPool;
function createWorkerPoolFromCode(workerCode, count) {
    var workerBlob = new Blob([workerCode], { type: "application/javascript" });
    var workerURL = URL.createObjectURL(workerBlob);
    var pool = new SimpleWorkerPool(workerURL, count);
    URL.revokeObjectURL(workerURL);
    return pool;
}
